/** 按视口宽度动态设置 html 根字号，使 rem 随屏幕等比缩放 */
const DESIGN_WIDTH = 1440
const BASE_FONT_SIZE = 16
const MIN_FONT_SIZE = 10
const MAX_FONT_SIZE = 18

function calcFontSize(width) {
  if (!width || width <= 0) return BASE_FONT_SIZE
  const size = (width / DESIGN_WIDTH) * BASE_FONT_SIZE
  return Math.min(MAX_FONT_SIZE, Math.max(MIN_FONT_SIZE, size))
}

export function setRem() {
  const width = document.documentElement.clientWidth || window.innerWidth || DESIGN_WIDTH
  document.documentElement.style.fontSize = `${calcFontSize(width)}px`
}

export function initRem() {
  setRem()
  window.addEventListener('resize', setRem, { passive: true })
  window.addEventListener('orientationchange', setRem, { passive: true })
}

export function destroyRem() {
  window.removeEventListener('resize', setRem)
  window.removeEventListener('orientationchange', setRem)
}
